import { ICON_TYPES } from '../constants';

export const FloorPlan = (): JSX.Element => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3633_10965)">
        <path
          d="M4 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5L0 4H1.5L1.4895 5.5L2.4895 5.505L2.5 4H4V2.492L5.5 2.5L5.505 1.5L4 1.492V0ZM3 3H1V1.5C1 1.36739 1.05268 1.24021 1.14645 1.14645C1.24021 1.05268 1.36739 1 1.5 1H3V3Z"
          fill="#2C2A27"
        />
        <path
          d="M10.5001 0H8.00006V1.5L6.50256 1.492L6.49756 2.492L8.00006 2.5V4H9.50756L9.50006 5.5L10.5001 5.505L10.5076 4H12.0001V1.5C12.0001 1.10218 11.842 0.720644 11.5607 0.43934C11.2794 0.158035 10.8979 0 10.5001 0V0ZM11.0001 3H9.00006V1H10.5001C10.6327 1 10.7598 1.05268 10.8536 1.14645C10.9474 1.24021 11.0001 1.36739 11.0001 1.5V3Z"
          fill="#2C2A27"
        />
        <path
          d="M10.5105 6.50256L9.5105 6.49756L9.5025 8.00006H8V9.50806L6.5025 9.50006L6.5 10.5001L8 10.5081V12.0001H10.5C10.8978 12.0001 11.2793 11.842 11.5607 11.5607C11.842 11.2794 12 10.8979 12 10.5001V8.00006H10.5L10.5105 6.50256ZM11 10.5001C11 10.6327 10.9473 10.7598 10.8535 10.8536C10.7598 10.9474 10.6326 11.0001 10.5 11.0001H9V9.00006H11V10.5001Z"
          fill="#2C2A27"
        />
        <path
          d="M4 7.99975H2.4925L2.5 6.50226L1.5 6.49976L1.4925 7.99975H0V10.4998C0 10.8976 0.158035 11.2791 0.43934 11.5604C0.720644 11.8417 1.10218 11.9997 1.5 11.9997H4V10.4998L5.5 10.5103L5.505 9.51025L4 9.50225V7.99975ZM3 10.9997H1.5C1.36739 10.9997 1.24021 10.9471 1.14645 10.8533C1.05268 10.7595 1 10.6324 1 10.4998V8.99975H3V10.9997Z"
          fill="#2C2A27"
        />
      </g>
      <defs>
        <clipPath id="clip0_3633_10965">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

FloorPlan.iconType = ICON_TYPES.FLOOR_PLAN;
